import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import getters from './getters';

import exercises from './exercises';
import matches from './matches';
import trainings from './trainings';
import notifications from './notifications';
import matchesEditor from './matches-editor';
import videotags from './videotags';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    exercises,
    matches,
    trainings,
    notifications,
    'matches-editor': matchesEditor,
    videotags,
  },
  state,
  mutations,
  getters,
});



// WEBPACK FOOTER //
// ./src/store/index.js